import { render, staticRenderFns } from "./BillHead.vue?vue&type=template&id=0f675381&scoped=true"
import script from "./BillHead.vue?vue&type=script&lang=js"
export * from "./BillHead.vue?vue&type=script&lang=js"
import style0 from "./BillHead.vue?vue&type=style&index=0&id=0f675381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f675381",
  null
  
)

export default component.exports